export default __webpack_public_path__ + "static/media/ThankyouDevice1.63a72183.png";